import type { ExpensePlan } from "../model/expenses.ts";

/** The spending planner's figures, kept in this browser only. */
const STORAGE_KEY = "fatfire-expense-plan-v1";

/** Browser storage can throw (private windows, blocked site data). Never let it break the page. */
export function loadExpensePlan(fallback: ExpensePlan): ExpensePlan {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return fallback;
    const parsed = JSON.parse(raw) as Partial<ExpensePlan>;
    return { ...fallback, ...parsed, overrides: parsed.overrides ?? {}, custom: parsed.custom ?? [] };
  } catch {
    return fallback;
  }
}

export function saveExpensePlan(plan: ExpensePlan): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(plan));
  } catch {
    /* storage unavailable: the plan still works for this visit */
  }
}

/** True while every line is still the standard figure and nothing was added. */
export function isStandardPlan(plan: ExpensePlan): boolean {
  return Object.keys(plan.overrides).length === 0 && plan.custom.length === 0;
}
